import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPageRoute: InvariantJiraRoute = {
	name: 'communications-status-page',
	path: '/jira/communications/status-page',
};
